import { computed, type MaybeRef, unref } from 'vue';
import { isNil } from 'lodash-es';
import { QueryClient, useQuery } from '@tanstack/vue-query';

import { getOrderById } from '../api';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    },
  },
});

function getQueryOptions(orderId: MaybeRef<string>) {
  return {
    queryKey: ['shop', 'orders', orderId],
    queryFn: () => getOrderById({ orderId: unref(orderId) }),
    enabled: computed(() => !isNil(unref(orderId))),
  };
}

export function invalidateOrderQuery(orderId: MaybeRef<string>) {
  queryClient.invalidateQueries(getQueryOptions(orderId));
}

export function fetchOrderQuery(orderId: MaybeRef<string>) {
  return queryClient.fetchQuery(getQueryOptions(orderId));
}

export function useOrderQuery(orderId: MaybeRef<string>) {
  return useQuery({ ...getQueryOptions(orderId), queryClient });
}
